const LEGAL_FORMS = {
  en: {
    legal_form_fop: 'FOP',
    legal_form_pp: 'PP',
    legal_form_tov: 'TOV',
    legal_form_pat: 'PAT',
    legal_form_prat: 'PrAT',
  },
  uk: {
    legal_form_fop: 'ФОП',
    legal_form_pp: 'ПП',
    legal_form_tov: 'ТОВ',
    legal_form_pat: 'ПАТ',
    legal_form_prat: 'ПрАТ',
  },
};

export const WarehouseSuppliers = {
  en: {
    ...LEGAL_FORMS.en,
    Suppliers: 'Suppliers',
    'Create Supplier': 'Create Supplier',
    Phone: 'Phone',
    'E-mail': 'E-mail',
    EDRPOU: 'EDRPOU',
    'Settlement Balance': 'Settlement Balance',
    'Supplier not found': 'Supplier not found',
    'Settle the balance first':
      'The supplier has a non-zero settlement balance and cannot be archived',
  },
  uk: {
    ...LEGAL_FORMS.uk,
    Suppliers: 'Постачальники',
    'Create Supplier': 'Створити постачальника',
    Phone: 'Телефон',
    'E-mail': 'E-mail',
    EDRPOU: 'ЄДРПОУ',
    'Settlement Balance': 'Баланс розрахунків',
    'Supplier not found': 'Постачальника не знайдено',
    'Settle the balance first':
      'У постачальника ненульовий баланс розрахунків — архівація неможлива',
  },
};

export const WarehouseSupplierForm = {
  en: {
    ...WarehouseSuppliers.en,
    'New Supplier': 'New Supplier',
    'Create Supplier': 'Create Supplier',
    'Edit Supplier': 'Edit Supplier',
    'Update Supplier': 'Update Supplier',
    Information: 'Information',
    'Legal Form': 'Legal Form',
    Website: 'Website',
    Notes: 'Notes',
    'Contact Persons': 'Contact Persons',
    'Add Contact Person': 'Add Contact Person',
    'Last Name': 'Last Name',
    'First Name': 'First Name',
    Patronymic: 'Patronymic',
    Position: 'Position',
    Requisites: 'Requisites',
    'Legal Address': 'Legal Address',
    'Actual address differs': 'Actual address differs',
    'Actual Address': 'Actual Address',
    address_postcode: 'Postcode',
    address_city: 'City',
    address_street: 'Street',
    address_building: 'Building',
    address_office: 'Office',
    IPN: 'IPN',
    'VAT Certificate': 'VAT Certificate',
    'Account Type': 'Account Type',
    'Account Number': 'Account Number',
    MFO: 'MFO',
    'Bank Name': 'Bank Name',
    'Settlements with the supplier': 'Settlements with the supplier',
    'Settlement currency': 'Settlement currency',
    'Changed only by operations': 'changed only by operations',
    'Name already taken': 'A supplier with this name already exists',
    'EDRPOU already taken': 'A supplier with this EDRPOU already exists',
  },
  uk: {
    ...WarehouseSuppliers.uk,
    'New Supplier': 'Новий постачальник',
    'Create Supplier': 'Створити постачальника',
    'Edit Supplier': 'Редагування постачальника',
    'Update Supplier': 'Оновити постачальника',
    Information: 'Інформація',
    'Legal Form': 'Правова форма',
    Website: 'Вебсайт',
    Notes: 'Нотатки',
    'Contact Persons': 'Контактні особи',
    'Add Contact Person': 'Додати контактну особу',
    'Last Name': 'Прізвище',
    'First Name': "Ім'я",
    Patronymic: 'По батькові',
    Position: 'Посада',
    Requisites: 'Реквізити',
    'Legal Address': 'Юридична адреса',
    'Actual address differs': 'Фактична адреса відрізняється',
    'Actual Address': 'Фактична адреса',
    address_postcode: 'Індекс',
    address_city: 'Місто',
    address_street: 'Вулиця',
    address_building: 'Будинок',
    address_office: 'Офіс',
    IPN: 'ІПН',
    'VAT Certificate': 'Свідоцтво ПДВ',
    'Account Type': 'Тип рахунку',
    'Account Number': 'Номер рахунку',
    MFO: 'МФО',
    'Bank Name': 'Назва банку',
    'Settlements with the supplier': 'Розрахунки з постачальником',
    'Settlement currency': 'Валюта розрахунків',
    'Changed only by operations': 'змінюється лише операціями',
    'Name already taken': 'Постачальник із такою назвою вже існує',
    'EDRPOU already taken': 'Постачальник із таким ЄДРПОУ вже існує',
  },
};
